/**
 * Why no Zuzahlungskennzeichen could be formed for an Abrechnungsfall (#1500).
 *
 * Same discipline and the same result shape as {@link CopaymentSkipReason} and
 * `GkvRoutingSkipReason`: the digit is a mandatory field of the §302 record and
 * is the *only* thing the Kasse learns about the Zuzahlung, so a guessed one is
 * a false statement about a patient's entitlement. Refusal sets the Fall aside;
 * a guess bills it wrongly.
 *
 * A separate enum from `CopaymentSkipReason` because it answers a different
 * question. Everything that stopped the **amount** reaches here as
 * {@link CopaymentIndicatorSkipReason.ZUZAHLUNG_NICHT_ERMITTELBAR} carrying the
 * original reason in its detail — the key cannot be righter than the sum it
 * stands beside.
 */
export var CopaymentIndicatorSkipReason;
(function (CopaymentIndicatorSkipReason) {
    /**
     * The Zuzahlungs-Soll itself came back *not determinable*.
     *
     * Propagated rather than re-diagnosed: the digit describes the same Fall as
     * the amount, so a Fall with no amount has no key either.
     */
    CopaymentIndicatorSkipReason["ZUZAHLUNG_NICHT_ERMITTELBAR"] = "zuzahlung nicht ermittelbar";
    /**
     * The Fall has no Leistungstag at all.
     *
     * The derivation compares the patient's status on the first against the last
     * Behandlungstag; with no day delivered there is no status to compare and
     * nothing to bill either.
     */
    CopaymentIndicatorSkipReason["KEIN_LEISTUNGSTAG"] = "kein leistungstag";
})(CopaymentIndicatorSkipReason || (CopaymentIndicatorSkipReason = {}));
//# sourceMappingURL=copayment-indicator-skip-reason.enum.js.map